import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPagePT() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Análise de Relacionamentos com IA | Detecte Padrões Tóxicos e Gaslighting" description="Descubra se seu ex é o problema. Carregue seus chats para a IA do ToxicDetector para análise instantânea e confidencial de manipulação, gaslighting e sinais de alerta. Comece a análise gratuita hoje." keywords="análise de relacionamento com IA, detectar padrões tóxicos, detector de gaslighting, ex tóxico, verificador de manipulação, toxicidade em relacionamento, scanner de texto com IA" canonical="https://toxicdetector.com/pt" language="pt-BR" alternateUrls={alternateUrls} data-id="element-8940" data-mp="i4wnt0tqr89k" />
      <GoogleTranslateWidget data-id="element-8941" data-mp="33pedxmq5fhhj" />
      <PromoBanner data-id="element-8942" data-mp="33r8xawlrv1ji" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-8943" data-mp="33qpi3nniar96">
        <Header data-id="element-8944" data-mp="2yp05i3kmy5iz" />
        <main data-id="element-8945" data-mp="2ysntyob841qu">
          <HeroSection h1Override={<>
                Seu Cérebro Está{' '}
                <span className="relative inline-block" data-id="element-8947" data-mp="1nc7eiuzo5l3z">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-8948" data-mp="1n9l50pt7wvj4">
                    Mentindo
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-8949" data-mp="18a7kf1phrr88" />
                </span>{' '}
                Para Você.
                <br data-id="element-8950" data-mp="1i6284b8kochv" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-8951" data-mp="1i5j0bncmz4hk">
                  Nossa IA Não.
                </span>
              </>} data-id="element-8946" data-mp="2ts062biak10u" />
          <TrustSection data-id="element-8952" data-mp="1qycm83ml924e" />
          <FeaturesSection data-id="element-8953" data-mp="1r18h1j353aom" />
          <GuaranteesSection data-id="element-8954" data-mp="1vxyxi7iuw8ak" />
          <ToolsSection data-id="element-8955" data-mp="1vx79bhrl9cub" />
          <ComparisonSection data-id="element-8956" data-mp="1vwe3qk4d8tdr" />
          <PricingSection data-id="element-8957" data-mp="20xbsxgnsmnor" />
          <FAQSection data-id="element-8958" data-mp="20x243wehimkn" />
          <CTASection data-id="element-8959" data-mp="20xv1w7vgu1qn" />
        </main>
        <Footer data-id="element-8960" data-mp="25wep0blspjkl" />
      </div>
    </>;
}